export default "__VITE_ASSET__COHJZDEa__"